import FirstRoundLetterComp from "components/FirstRoundLetter/FirstRoundLetter";
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import arrowDown from "../../assets/img/Sidebar/sidebar-arrow-down.svg";
import arrowUp from "../../assets/img/Sidebar/sidebar-arrow-up.svg";
import albaitLogo from "../../assets/img/albait-logo.png";
import avatar from "../../assets/img/avatar_5.svg";
import crown from "../../assets/img/common/crown.svg";
import arrowWhite from "../../assets/img/icons/arrow-white.svg";
import hamburgerIcon from "../../assets/img/icons/hamburger.svg";
import logo from "../../assets/img/logo/fs_icon26.svg";
import logoTxt from "../../assets/img/logo/fs_logo_name26.svg";
import CustomScrollbars from "../../components/CustomScrollbars/CustomScrollbars";
import { createNotification } from "../../modules/notificationManager";
import routes from "../../routes";
import { ColoredButtonWithIcon } from "../../styledComponents/buttons";
import { CenteredTooltip, RoundMiniImage } from "../../styledComponents/common";
import { getTwoLetter } from "../../utils/helper";
// import ProfilePopup from "./ProfilePopup";
import OrgAndProfilePopup from "./OrgAndProfilePopup";
import QuickActionsPanel from "../QuickActions/QuickActionsPanel";
import StickyActionsSection from "./StickyActionsSection";
import {
  SeeMoreView,
  generateGroupedLinks,
  getCollapsedStates,
  getLinkView,
} from "./sidebarHelpers";
import {
  LinkGroup,
  LinkGroupTitle,
  LinksAndProfileSectionWrapper,
  LogoContainer,
  LogoIcon,
  LogoIconDiv,
  LogoLink,
  LogoText,
  NameAndOrgDiv,
  OrgAndProfileContainer,
  OrgIcon,
  OrgName,
  PictureTooltipContainer,
  PopupArrowDiv,
  PopupArrowIcon,
  ProfilePicture,
  SidebarArrowIcon,
  SidebarCollapseButton,
  SidebarCollapseButtonIcon,
  SidebarContainer,
  SidebarLinksWrapper,
  SidebarNav,
  UpgradeButtonContainer,
  UserName,
} from "./sidebarStyles";

const OrgAndProfileSection = ({
  selectedOrganization,
  selectOrganization,
  organizations,
  history,
  loginProfileCreatedReset,
  sidebarMini,
  clearNavOpen,
  profile,
  handleNavOpen,
}) => {
  const [orgAndProfilePopupOpen, setOrgAndProfilePopupOpen] = useState(false);

  const [activeOrgsList, setActiveOrgsList] = useState([]);
  const [archivedOrgsList, setArchivedOrgsList] = useState([]);
  const [selectedOrgId, setSelectedOrgId] = useState(
    localStorage.getItem("selected_organization_id"),
  );
  const [selectedOrgName, setSelectedOrgName] = useState(
    localStorage.getItem("selected_organization"),
  );
  const [selectedOrgColor, setSelectedOrgColor] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);

  

  const selectFirstActiveOrg = list => {
    const orgList =
      list &&
      list.length &&
      list.filter(organization => organization.is_active === true);
    if (orgList && orgList.length > 0) {
      selectOrg(orgList[0], false); // false = initialization, don't show notification
    }
  };

  useEffect(() => {
    if (organizations && organizations.list) {
      if (!organizations.selectedOrganization) {
        const selectedOrgId = localStorage.getItem("selected_organization_id");
        if (selectedOrgId) {
          let selectedOrg;
          if (organizations.list && organizations.list.length) {
            organizations.list.some(organization => {
              if (organization.id === selectedOrgId) {
                selectedOrg = organization;
                return true;
              }
              return false;
            });
          }
          if (selectedOrg) {
            selectOrg(selectedOrg, false); // false = initialization, don't show notification
          } else {
            selectFirstActiveOrg(organizations.list);
          }
        } else {
          selectFirstActiveOrg(organizations.list);
        }
      }
      if (organizations.list.length > 0) {
        const activeList = [];
        const archivedList = [];
        organizations.list.map((org, index) => {
          if (org.is_active) {
            activeList.push(org);
          } else {
            archivedList.push(org);
          }
        });
        setActiveOrgsList(activeList);
        setArchivedOrgsList(archivedList);
      } else if (organizations.list.length === 0) {
        setActiveOrgsList([]);
        setArchivedOrgsList([]);
      }
      // Mark as initialized after first org load
      if (!isInitialized && organizations.list.length > 0) {
        setIsInitialized(true);
      }
    }
    if (
      organizations &&
      organizations.selectedOrganization &&
      (!selectedOrgName ||
        !selectedOrgColor ||
        selectedOrgId !== organizations.selectedOrganization.id ||
        selectedOrgName !== organizations.selectedOrganization.name) &&
      organizations.selectedOrganization.id
    ) {
      localStorage.setItem(
        "selected_organization",
        organizations.selectedOrganization.name,
      );
      localStorage.setItem(
        "selected_organization_id",
        organizations.selectedOrganization.id,
      );
      setSelectedOrgId(organizations.selectedOrganization.id);
      setSelectedOrgName(organizations.selectedOrganization.name);
      setSelectedOrgColor(organizations.selectedOrganization.color);
    }
  }, [organizations]);

  let userFirstName;
  const userFullName = localStorage.getItem("user_fullName");
  if (userFullName) {
    userFirstName = userFullName.split(" ")[0];
  }
  const userEmail = localStorage.getItem("email");

  const selectOrg = (item, isUserInitiated = true) => {
    localStorage.setItem("selected_organization", item.name);
    localStorage.setItem("selected_organization_id", item.id);
    localStorage.setItem("selected_organization_role", item.role);
    selectOrganization(item);
    // Show notification only when user manually switches organization (after initialization)
    if (isUserInitiated && isInitialized) {
      createNotification("success", `Switched to ${item.name}`, 2000);
    }
  };

  const closePopup = () => {
    setOrgAndProfilePopupOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user_role");
    localStorage.removeItem("viewer_role");
    localStorage.removeItem("user_profile");
    localStorage.removeItem("user_fullName");
    localStorage.removeItem("selected_organization");
    localStorage.removeItem("selected_organization_id");
    localStorage.removeItem("selected_organization_role");
    localStorage.removeItem("selected_organization_plan");
    localStorage.removeItem("email");
    localStorage.removeItem("created_at");
    localStorage.removeItem("is_owner");
    localStorage.removeItem("user_timezone");
    history.push("/auth/login");
    loginProfileCreatedReset();
  };
  return (
    <LinksAndProfileSectionWrapper>
      <StickyActionsSection
        history={history}
        sidebarMini={sidebarMini}
        selectedOrganization={selectedOrganization}
        handleNavOpen={handleNavOpen}
      />
      <OrgAndProfileContainer sidebarMini={sidebarMini}>
        <OrgAndProfilePopup
          closePopup={closePopup}
          popupOpen={orgAndProfilePopupOpen}
          sidebarMini={sidebarMini}
          history={history}
          handleLogout={handleLogout}
          clearNavOpen={clearNavOpen}
          profilePicture={
            (profile && profile.profileData && profile.profileData.thumbnail) ||
            avatar
          }
          userTimezone={
            profile && profile.profileData && profile.profileData.timezone
          }
          userFullName={userFullName}
          userEmail={userEmail}
          userColor={profile.profileData.color}
          selectedOrganization={selectedOrganization}
          selectOrg={selectOrg}
          selectedOrgId={selectedOrgId}
          activeOrgsList={activeOrgsList}
          archivedOrgsList={archivedOrgsList}
          handleNavOpen={handleNavOpen}
        />
        {selectedOrganization && selectedOrganization.id && (
          <OrgIcon
            bgColor={selectedOrganization && selectedOrganization.color}
            active={selectedOrganization && selectedOrganization.is_active}
            margin="0 -10px 0 0"
            $size={sidebarMini && "30px"}
            fontSize={sidebarMini ? "12px" : "14px"}
            onClick={() => setOrgAndProfilePopupOpen(true)}
          >
            <CenteredTooltip left="0px" top="-35px">
              {selectedOrgName}
            </CenteredTooltip>
            {selectedOrgName && getTwoLetter(selectedOrgName)}
          </OrgIcon>
        )}

        <PictureTooltipContainer>
          {profile && profile.profileData && profile.profileData.thumbnail ? (
            <ProfilePicture
              $size={sidebarMini && "30px"}
              cursor="pointer"
              src={
                (profile &&
                  profile.profileData &&
                  profile.profileData.thumbnail) ||
                avatar
              }
              alt=""
              onClick={() => setOrgAndProfilePopupOpen(true)}
            />
          ) : (
            <div style={{ cursor: "pointer" }}>
              <FirstRoundLetterComp
                text={userFullName}
                backColor={0}
                color={profile.profileData.color}
                onClick={() => setOrgAndProfilePopupOpen(true)}
              />
            </div>
          )}

          <CenteredTooltip left="0px" top="-35px">
            {userFullName}
          </CenteredTooltip>
        </PictureTooltipContainer>

        <PopupArrowDiv onClick={() => setOrgAndProfilePopupOpen(true)}>
          <PopupArrowIcon
            marginLeft="0"
            src={arrowWhite}
            alt=""
            popupOpen={orgAndProfilePopupOpen}
          />
        </PopupArrowDiv>
      </OrgAndProfileContainer>
    </LinksAndProfileSectionWrapper>
  );
};

const Sidebar = ({
  selectedOrganization,
  selectOrganization,
  getOrganizationList,
  organizations,
  profile,
  clearNavOpen,
  history,
  sidebarMini,
  loginProfileCreatedReset,
  location,
  handleMiniClick,
  navOpen,
  handleNavOpen,
  routes: routesProp,
}) => {
  const [windowWidth, setWindowWidth] = useState(0);
  const [sidebarLinks, setSidebarLinks] = useState(null);
  const [collapseState, setCollapseState] = useState(
    getCollapsedStates(routes),
  );
  const [showSidebarToggle, setShowSidebarToggle] = useState(false);
  const [filteredRoutes, setFilteredRoutes] = useState([]);
  const [quickActionsState, setQuickActionsState] = useState({ isOpen: false });
  const quickActionsAnchorRef = useRef(null);

  

  useEffect(() => {
    // Default to "operation" if type is not defined
    const orgType = selectedOrganization?.type || "operation";
    // Determine role (fallback to localStorage for initial load)
    const userRole =
      selectedOrganization?.role ||
      localStorage.getItem("selected_organization_role") ||
      "";

    const filterRoutes = routesArr => {
      return routesArr
        .map(route => {
          if (route.collapse && route.views) {
            return { ...route, views: filterRoutes(route.views) };
          }
          return route;
        })
        .filter(route => {
          // Exclude restricted routes for current role
          if (
            route.restricted &&
            Array.isArray(route.restricted) &&
            userRole &&
            route.restricted.includes(userRole)
          ) {
            return false;
          }
          // Remove empty collapses
          if (route.collapse && route.views && route.views.length === 0)
            return false;
          // If no type specified, include route
          if (!route.type) return true;
          // Check if route type matches organization type
          return route.type === orgType;
        });
    };
    const routesToFilter = routesProp && routesProp.length > 0 ? routesProp : routes;
    const allowedRoutes = filterRoutes(routesToFilter);
    setFilteredRoutes(allowedRoutes);
  }, [
    selectedOrganization?.id,
    selectedOrganization?.type,
    selectedOrganization?.role,
    routesProp,
  ]);

  useEffect(() => {
    updateSize();
    window.addEventListener("resize", updateSize);

    getOrganizationList();

    return () => {
      window.removeEventListener("resize", updateSize);
    };
  }, []);

  useEffect(() => {
    setSidebarLinks(generateGroupedLinks(filteredRoutes, selectedOrganization));
  }, [filteredRoutes, selectedOrganization]);

  const updateSize = () => {
    setWindowWidth(window.innerWidth);
  };

  const { t } = useTranslation();

  // Check if current plan is free and user is owner - memoized to avoid recalculation on every render
  const isFreePlan = useMemo(() => {
    const isFree =
      selectedOrganization?.plan?.name === "Free" ||
      selectedOrganization?.plan?.nick_name === "standard-free" ||
      selectedOrganization?.plan?.nick_name === "elite-free";
    const isOwner = selectedOrganization?.role === "owner";
    return isFree && isOwner;
  }, [
    selectedOrganization?.plan?.name,
    selectedOrganization?.plan?.nick_name,
    selectedOrganization?.role,
  ]);

  const handleUpgradeClick = () => {
    history.push("/user/subscription");
  };

  return (
    <SidebarContainer
      sidebarMini={sidebarMini}
      navOpen={navOpen}
      onMouseEnter={() => setShowSidebarToggle(true)}
      onMouseLeave={() => setShowSidebarToggle(false)}
    >
      {showSidebarToggle && (
        // <HamburgerIconContainer>
        //   <HamburgerIcon
        //     src={hamburgerIcon}
        //     alt=""
        //     onClick={() => handleMiniClick()}
        //   />
        // </HamburgerIconContainer>
        <SidebarCollapseButton onClick={() => handleMiniClick()}>
          <SidebarCollapseButtonIcon
            sidebarMini={sidebarMini}
            src={arrowDown}
            alt=""
          />
        </SidebarCollapseButton>
      )}
      <LogoContainer>
        <LogoLink
          // target="_blank"
          // rel="noopener noreferrer"
          // href="https://app.fieldservicely.com"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            handleNavOpen();
            history.push("/user/dashboard");
          }}
          style={{cursor: "pointer"}}
        >
          <LogoIconDiv>
            <LogoIcon src={logo} alt="" />
          </LogoIconDiv>
        </LogoLink>
        <LogoLink
          // target="_blank"
          // rel="noopener noreferrer"
          // href="https://app.fieldservicely.com"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            handleNavOpen();
            history.push("/user/dashboard");
          }}
          style={{cursor: "pointer"}}
        >
          <LogoText src={logoTxt} alt="" />
        </LogoLink>
        {/* Upgrade Button - Only show when plan is free */}
        {/* {isFreePlan && !sidebarMini && (
          <UpgradeButtonContainer>
            <ColoredButtonWithIcon
              height="25px"
              margin="0 0 0 15px"
              padding="0 15px"
              fontSize="12px"
              bgColor="#FFC107"
              onClick={handleUpgradeClick}
            >
              <img
                src={crown}
                alt=""
                style={{ width: "16px", height: "16px" }}
              />
              UPGRADE
            </ColoredButtonWithIcon>
          </UpgradeButtonContainer>
        )} */}
      </LogoContainer>
      <div style={{ flex: 1, minHeight: 0, }}>
        <CustomScrollbars
          style={{
            height: `calc(100vh - 170px)`,
            zIndex: 5,
            overflowX: "hidden",
          }}
          renderView={props => (
            <div {...props} style={{ ...props.style, overflowX: "show" }} />
          )}
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
        >
          <SidebarLinksWrapper sidebarMini={sidebarMini}>
            {sidebarLinks &&
              Object.keys(sidebarLinks).map((group, index) => {
                return (
                  <LinkGroup key={index}>
                    {!sidebarMini && group !== "Common" && (
                      <LinkGroupTitle fontSize="13px">
                        {t(group)}
                      </LinkGroupTitle>
                    )}
                    <SidebarNav>
                      {sidebarLinks[group] &&
                        sidebarLinks[group].length > 0 &&
                        sidebarLinks[group].map((link, index) => {
                          return getLinkView(
                            selectedOrganization,
                            link,
                            index,
                            collapseState,
                            setCollapseState,
                            location,
                            sidebarMini,
                            t,
                            handleNavOpen,
                            quickActionsState,
                            setQuickActionsState,
                            quickActionsAnchorRef,
                          );
                        })}
                    </SidebarNav>
                  </LinkGroup>
                );
              })}
            <SeeMoreView
              organization={selectedOrganization}
              location={location}
              handleNavOpen={handleNavOpen}
              sidebarMini={sidebarMini}
            />
          </SidebarLinksWrapper>
        </CustomScrollbars>
      </div>
      <OrgAndProfileSection
        sidebarMini={sidebarMini}
        history={history}
        profile={profile}
        loginProfileCreatedReset={loginProfileCreatedReset}
        clearNavOpen={clearNavOpen}
        organizations={organizations}
        selectedOrganization={selectedOrganization}
        selectOrganization={selectOrganization}
        handleNavOpen={handleNavOpen}
      />
      <QuickActionsPanel
        isOpen={quickActionsState.isOpen}
        onClose={() => setQuickActionsState({ isOpen: false })}
        selectedOrganization={selectedOrganization}
        anchorRef={quickActionsAnchorRef}
      />
    </SidebarContainer>
  );
};

export default Sidebar;
